import { render, staticRenderFns } from "./InventorySelfList.vue?vue&type=template&id=9d5260b8&scoped=true"
import script from "./InventorySelfList.vue?vue&type=script&lang=js"
export * from "./InventorySelfList.vue?vue&type=script&lang=js"
import style0 from "./InventorySelfList.vue?vue&type=style&index=0&id=9d5260b8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d5260b8",
  null
  
)

export default component.exports